import { useEffect, useState } from "react";

// import { Checkbox } from "@mui/material";
import { SELECTS_ID } from "@store/company/procedure-instrunctions-store";
import Chip from "@mui/material/Chip";

import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import clsx from "clsx";
import style from "./drop-down-multi-select.module.scss";

type SelectListType = {
  id: number;
  title: string;
};

type PropsDropDownMultiSelect = {
  title?: string;
  size?: string;
  typeStyle?: "input";
  defaultTitle?: string;
  defaultValue?: number[];
  direction: { id: number; title: string }[];
  handlerChange?: (value: string) => void;
  handlerList?: (values: SelectListType[]) => void;
  reset?: boolean;
  handlerReset?: () => void;
  selectOnly?: number;
  typeSelect?: string;
  // TODO: убрать этот проп и поменять SELECTS_ID везде с 99999 на -1
  allId?: number;
};

export const DropDownMultiSelect: React.FC<PropsDropDownMultiSelect> = ({
  title,
  size,
  typeSelect,
  reset = false,
  handlerReset,
  typeStyle,
  defaultTitle,
  defaultValue,
  direction,
  handlerChange,
  handlerList,
  selectOnly,
  allId = SELECTS_ID,
}) => {
  const [ids, setIds] = useState<number[]>(defaultValue ?? [allId]);
  const [fullListID, setFullListID] = useState<number[]>([]);
  const [valueInput, setValueInput] = useState<string>(title ?? "");
  const [upadteProgram, setUpdateProgram] = useState<SelectListType[]>([]);
  const [open, setOpen] = useState<boolean>(false);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  useEffect(() => {
    if (selectOnly) {
      setIds([selectOnly]);

      const updatedList = direction.filter(
        (item) => item.id !== allId && selectOnly === item.id
      );
      handlerList?.(updatedList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectOnly]);

  useEffect(() => {
    if (reset) {
      handlerList?.(direction);
      setIds(fullListID);
      handlerReset && handlerReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  useEffect(() => {
    const updatedList = direction.filter(
      (item) => item.id !== allId && ids.includes(item.id)
    );
    setUpdateProgram(updatedList);

    if (ids.length === 0) {
      return setValueInput(defaultTitle ?? "Выбрать все");
    }

    if (!!ids.length) {
      const firstId = ids.sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));
      const inputAllSelects = !!ids.find((item) => item === allId);

      if (inputAllSelects && !title) {
        return setValueInput(defaultTitle ?? "Выбрать все");
      }

      if (!inputAllSelects) {
        if (typeStyle === "input") {
          const updatedList = direction.filter(
            (item) => item.id !== allId && ids.includes(item.id)
          );
          !title &&
            setValueInput(
              updatedList.map((direction) => direction.title).join(", ")
            );
          return;
        }

        direction.find(
          (item) =>
            item.id === firstId[0] && !title && setValueInput(item.title)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);

  useEffect(() => {
    if (title) setValueInput(title);
  }, [title]);

  useEffect(() => {
    const arr: number[] = direction.map((item) => item.id);
    setFullListID(arr);
    const updatedList = direction.filter(
      (item) => item.id !== allId && arr.includes(item.id)
    );
    setUpdateProgram(updatedList);
    // handlerList(updatedList); // commented out because it was causing infinite loop in `WorkplanGroup` but left it here if in future issues will appear
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [direction]);

  useEffect(() => {
    if (!!fullListID.length) {
      const inputAllSelects = !!ids.find((item) => item === allId);
      if (inputAllSelects) {
        setIds(fullListID);
        if (!title) {
          return setValueInput(defaultTitle ?? "Выбрать все");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullListID]);

  const onChange = (event: any, value: SelectListType[]) => {
    const clearAllSelects =
      !value.find((item) => item.id === allId) &&
      !!ids.find((item) => item === allId) &&
      value.length > 0;
    const addAllSelects =
      !!value.find((item) => item.id === allId) &&
      !ids.find((item) => item === allId) &&
      value.length > 0;
    if (clearAllSelects) return setIds([]);
    if (addAllSelects || (value.length === 0 && !open))
      return setIds(fullListID);

    return setIds(value.map((e) => e.id));
  };

  const handleSelectClose = () => {
    setOpen(false);
    if (ids.length === 0) {
      setIds(fullListID);
      handlerChange && handlerChange(fullListID.join(","));
      handlerList && handlerList(direction.filter((item) => item.id !== allId));
    } else {
      handlerChange && handlerChange(ids.join(","));
      handlerList && handlerList(upadteProgram);
    }
  };

  return (
    <div
      className={clsx(style.container_n, {
        [style.container_n_big]: size === "big",
        [style.container_n_medium]: size === "medium",
      })}
    >
      {direction && (
        <Autocomplete
          multiple
          fullWidth
          disableCloseOnSelect
          size="small"
          options={direction}
          limitTags={1}
          getOptionLabel={(option) => option.title}
          value={ids
            .filter((e) => !!direction.find((f) => f.id === e))
            .map((e) => direction.find((f) => f.id === e) as SelectListType)}
          onChange={onChange}
          onClose={handleSelectClose}
          onOpen={() => {
            setOpen(true);
          }}
          // open
          noOptionsText={"Нет совпадений"}
          slotProps={{
            popper: {
              popperOptions: {
                placement: "bottom-start",
              },
              sx: {
                width: "auto !important",
                maxWidth: "30vw",
                top: "0px",
              },
            },
          }}
          renderTags={(value: SelectListType[], getTagProps) =>
            value.map((option: SelectListType, index: number) => {
              const { key, ...tagProps } = getTagProps({ index });
              tagProps.disabled = option.id === allId;
              return (
                <Chip
                  variant="outlined"
                  size="small"
                  label={option.title}
                  key={key}
                  {...tagProps}
                />
              );
            })
          }
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            return (
              <li
                key={option.id}
                {...optionProps}
                className={style.checked_list_n}
              >
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                <span>{option.title}</span>
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="filled"
              label={valueInput}
              placeholder="Введите значение"
              className={clsx(
                style.box_input_n,
                { [style.box_input_n_big]: typeStyle !== "input" },
                {
                  [style.box_input_n_smile]: typeStyle === "input",
                }
              )}
            />
          )}
        />
      )}
    </div>
  );
};
